import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations } from 'vuexfire'

import snackbar from './modules/snackbar'
import contents from './modules/contents'
import devices from './modules/devices'
import playlists from './modules/playlists'
import schedules from './modules/schedules'
import backgrounds from './modules/backgrounds'
import users from './modules/users'
import reports from './modules/reports'
import tokens from './modules/tokens'
import interfaceControls from './modules/interfaceControls'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    interfaceControls,
    snackbar,
    contents,
    devices,
    playlists,
    schedules,
    backgrounds,
    users,
    reports,
    tokens
  },
  // Have to set vuexfireMutations at root.
  // reference: https://vuefire.vuejs.org/vuexfire/getting-started.html#adding-mutations.
  mutations: {
    ...vuexfireMutations
  }
})

export default store
